module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-300-book-italic-9c032e9d71abcc7e87fda8f352db5fcf.woff";